import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const CuposClasesApi = `${baseApi}/class-spots`;

export const getAllCuposClasesService = async (params) => {
  const res = await axios.get(CuposClasesApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveCuposClasesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${CuposClasesApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${CuposClasesApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneCuposClasesService = async (id) => {
  const res = await axios.get(`${CuposClasesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteCuposClasesService = async (id) => {
  const res = await axios.delete(`${CuposClasesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
